import PageMeta from "@/components/seo/PageMeta";
import Button from "@/components/ui/Button";
import ScriptText from "@/components/ui/ScriptText";
import { notFoundContent } from "@/data/content";
import { useContent } from "@/hooks/useContent";

export default function NotFoundPage() {
  const content = useContent("pages/not-found", notFoundContent);
  return (
    <>
      <PageMeta
        title="Page Not Found — Chasing Provence Retreats"
        description="The page you're looking for doesn't exist. Return to Chasing Provence to explore our retreats."
        noindex
      />

      <div className="flex min-h-screen items-center justify-center px-6">
        <div className="text-center">
          <ScriptText className="mb-4 block text-6xl">404</ScriptText>
          <h1 className="mb-4 font-serif text-3xl font-light text-soft-charcoal lg:text-4xl">
            {content.heading}
          </h1>
          <p className="mx-auto mb-10 max-w-md font-body leading-relaxed text-soft-charcoal/70">
            {content.body}
          </p>
          <Button to={content.ctaLink}>{content.ctaText}</Button>
        </div>
      </div>
    </>
  );
}
